export default "__VITE_ASSET__BtRYAZt2__"